<template> 
  <!-- переписать как галерею - с массивом imglinksmassif-->
  
    <template v-if="mode === 'view'">
              <!--desktop-->
      <div class="d-none d-sm-none d-md-flex rounded-0">

<!--{{ v }}-->

        <!--v-carousel v-if="imagesGallery.length > 0"
        show-arrows="hover"
        hide-delimiters
        height="200"
        >
          <v-carousel-item
            v-for="(img, index) in imagesGallery"
            :key="index"
            :title="img.title"
            :content="img.license"
            :src="img.link"
            cover
          >
  <div class="px-lg-4">
            <v-btn
              class="d-none d-sm-none d-md-flex rounded-0"
              variant="flat"
              color="accent"
              @click="overlay = !overlay, imgsrc = img.link"
              >
                Full
            </v-btn>
  </div>
          </v-carousel-item>
        </v-carousel-->
        <v-slide-group 
  
        v-if="imagesGallery.length > 0"
        v-model="model"
  
        selected-class="bg-vs"
      >
        <v-slide-group-item
          
          v-for="(img, index) in imagesGallery"
          :key="index"
        >
        <v-card @click="overlay = !overlay, imgsrc = prefixpath+img.link" class="mr-2 rounded-0">
          <v-img 
          width="300"
        height="300"
            aspect-ratio="1/1"
            cover
            :src=prefixpath+img.small
            >
  <!-- Везде положить плейсхолдер - чтобы было понятно что что-то грузится -->
            <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="regular"
                  indeterminate
                ></v-progress-circular>
              </div>
            </template>
  <!-- Везде положить плейсхолдер - чтобы было понятно что что-то грузится -->
          </v-img>
        </v-card> 
  
        <!--v-card @click="overlay = !overlay, imgsrc = img.link"
        
        class="mx-auto mr-2 mb-2 rounded-0"
        max-width="200"
        height="200"
        :image=img.link
        title=""
        theme="dark"
        >
        </v-card-->
  
  
          <!--v-card
            class="mr-2 mb-2 rounded-0"
            width="200"
            @click="overlay = !overlay, imgsrc = img.link"
          > 
          <v-img
          :src="img.link"/> 
          </v-card-->
        </v-slide-group-item>
      </v-slide-group>
  
  
        <v-dialog v-model="overlay" fullscreen><!--диалог оверлея для фуллскрина - как он отлавливает нужную картинку?-->
              <v-card class="overflow-auto rounded-0">
                <v-img 
                  :src="imgsrc"
                >
  <!-- Везде положить плейсхолдер - чтобы было понятно что что-то грузится -->
            <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="regular"
                  indeterminate
                ></v-progress-circular>
              </div>
            </template>
  <!-- Везде положить плейсхолдер - чтобы было понятно что что-то грузится -->
                
                  <v-btn
                    rounded="0"
                    variant="flat"
                    color="regular"
                    @click.stop="overlay = !overlay"
                  >
                    Close
                  </v-btn>
  
                  <!-- <v-btn 
     class="ma-2" 
     outlined 
     :href=imgsrc
     download>
         Download
  </v-btn> -->
  
                </v-img>
              </v-card>
            </v-dialog>
      </div>
      <div class="d-flex d-sm-none d-none d-sm-flex d-md-none"><!--mobile-->
        <v-carousel v-if="imagesGallery.length > 0"
          :show-arrows="false"
          height="400"
        >
          <v-carousel-item
            v-for="(img, index) in imagesGallery"
            :key="index"
            :title=img.title
            :content="img.license"
            :src=prefixpath+img.small
            cover
          >

          <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="regular"
                  indeterminate
                ></v-progress-circular>
              </div>
          </template>

          </v-carousel-item>
        </v-carousel>
      </div>  
    </template>
  <!--          v-if="v && v!=='null' && v!=='' && imagesGallery !== ''" -->
    <template v-else-if="mode === 'table'">
          <v-btn
          v-if="modelValue && modelValue!=='null' && modelValue!=='' && imagesGallery !== ''"
              class="my-1 mr-1"  
              variant="outlined"
              color="regular"
              @click="showimagedialog = !showimagedialog"
  
  
          >
          {{ imagesGallery.length }} img
          </v-btn>
  
  <!--          v-if="v && v!=='null'"-->
  
      <v-dialog
         
        v-model="showimagedialog"
        fullscreen
      >
      <v-card class="overflow-auto rounded-0 py-10">
        <v-carousel
        show-arrows="hover"
        hide-delimiters
        >
          <v-carousel-item
            v-for="(img, index) in imagesGallery"
            :key="index"
            :title="img.title"
            :content="img.license"
            :src=prefixpath+img.link
            cover
          >

          <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="regular"
                  indeterminate
                ></v-progress-circular>
              </div>
          </template>
  
            <v-btn
              class="rounded-0 mr-4"
              variant="flat"
              color="regular"
              @click.stop="showimagedialog = !showimagedialog"
              >
                Close
            </v-btn>
  
            <v-btn
              class="rounded-0"
              variant="flat"
              color="accent"
              @click="overlay = !overlay, imgsrc = prefixpath+img.link"
              >
                Full
            </v-btn>
  
  
            <v-dialog v-model="overlay" fullscreen
            ><!--диалог оверлея для фуллскрина - как он отлавливает нужную картинку?-->
              <v-card class="overflow-auto rounded-0">
                <v-img 
                  :src="imgsrc"
                > 
  <!-- Везде положить плейсхолдер - чтобы было понятно что что-то грузится -->
            <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="regular"
                  indeterminate
                ></v-progress-circular>
              </div>
            </template>
  <!-- Везде положить плейсхолдер - чтобы было понятно что что-то грузится -->
                  <v-btn
                    rounded="0"
                    variant="flat"
                    color="regular"
                    @click.stop="overlay = !overlay"
                  >
                    Close
                  </v-btn>
                </v-img>
              </v-card>
            </v-dialog>
          </v-carousel-item>
        </v-carousel>
      </v-card>  
      </v-dialog>
    </template>
  
    <template v-else-if="mode === 'edit'">
      <v-btn v-if="imagesGallery == ''" color="regular" class="mr-2 my-1" @click="dialogaddpicture = !dialogaddpicture, actionadd = !actionadd, fileinputfield=true">Add New File</v-btn>
<!-- add v-if v-else on imagesGallery exist-->
      <div v-if="imagesGallery !==''" class="d-none d-sm-none d-md-flex rounded-0">
        <v-slide-group 
        v-if="imagesGallery.length > 0"
        v-model="model"
        selected-class="bg-vs"
        class="mb-1"
      >
        <v-slide-group-item
          v-for="(img, index) in imagesGallery"
          :key="index"
        > 
        <v-card @click="overlay = !overlay, imgsrc = prefixpath+img.link" class="mr-2 rounded-0">
  
          <v-img 
          width="200"
        height="200"
            aspect-ratio="1/1"
            cover
            :src=prefixpath+img.small
            > 
            <v-btn class="mr-1, ml-1, ma-1" @click="indexImg=index, dialogedpicture = !dialogedpicture, preEdit()">Edit</v-btn>
            <v-btn class="mr-1" @click="indexImg=index, updateImgDataMassif('deleteimg')">Delete</v-btn>
  
            <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="regular"
                  indeterminate
                ></v-progress-circular>
              </div>
            </template>
          </v-img>
        </v-card> 
        </v-slide-group-item>
        <v-btn class="mr-2" @click="dialogaddpicture = true, actionadd = true, fileinputfield=!fileinputfield, indexImg = 1">Add New File</v-btn> 
        <!--indexImg = 1 - it is bad idea. Need find some like "index+1"-->
      </v-slide-group>
      </div>



  <v-dialog v-model="dialogedpicture">
    <v-card class="rounded-0 px-1">
      <v-card-text>
<!---->
<v-row>
<v-col cols-12 md-6 style="min-width: 300px; max-width: 350px">
  <v-img
    max-width="300"
    :src=prefixpath+vparsed[indexImg].small> 
  
    <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="regular"
                  indeterminate
                ></v-progress-circular>
              </div>
            </template>
  
  </v-img>
</v-col>
<v-col cols-12 md-6 style="min-width: 300px; max-width: 350px">
<div>
  <v-select variant="outlined" label="License" v-model="license" v-model:license="vparsed[indexImg].license" :items="['CC-BY-SA', 'Copyright', 'CC-0']"></v-select>
  <v-text-field variant="outlined" label="Authors" v-model="authors" v-model:authors="vparsed[indexImg].authors" name="authors"></v-text-field> 
  <v-text-field variant="outlined" label="Title" v-model="title" v-model:title="vparsed[indexImg].title" name="titlefield"></v-text-field>
</div>
<div class="d-flex justify-space-between">
    <v-btn class="my-1" variant="outlined" color="regular" @click="dialogedpicture = !dialogedpicture, datafieldsmenu = !datafieldsmenu, actionedit = false">Exit</v-btn>
  <v-btn  class="my-1" @click="dialogedpicture = !dialogedpicture, updateImgDataMassif('editimg'), datafieldsmenu = !datafieldsmenu, actionedit = false">Edit</v-btn>
</div>
</v-col>
</v-row>

<!---->
    </v-card-text>
    </v-card>
    <!-- сделать его только для того, чтобы менять данные в строке автор, лицензия или название-->
  </v-dialog>

  <v-dialog v-model="dialogaddpicture">
      <v-card class="rounded-0 px-1">
        <v-card-text>
        <v-sheet>
          <v-file-input v-if="fileinputfield" multiple label="Img" variant="outlined" ref="files" @change="handleFileUpload()"> </v-file-input>
        </v-sheet>

    <v-container style="height: 300px;" v-if="filesprogress">
      <v-row
        align-content="center"
        class="fill-height"
        justify="center"
      >
        <v-col
          class="text-subtitle-1 text-center"
          cols="12"
        >
          Please wait, the file is loading
        </v-col>
        <v-col cols="6">
          <v-progress-linear
            color="regular"
            height="50"
            indeterminate
            rounded
          ></v-progress-linear>
        </v-col>
      </v-row>
    </v-container>
<v-row>
<v-col cols-12 md-6 style="min-width: 300px; max-width: 350px">
  <v-img v-if="datafieldsmenu"
    max-width="300"
    :src=prefixpath+fileobject.small> <!-- ??????? надо заменить vparsed - потому что для индекса +1 - его еще нет-->
  
    <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="regular"
                  indeterminate
                ></v-progress-circular>
              </div>
            </template>
  
  </v-img>
</v-col>
<v-col cols-12 md-6 style="min-width: 300px; max-width: 350px">
<div v-if="datafieldsmenu">
  <v-select variant="outlined" label="License" v-model="license" v-model:license="fileobject.license" :items="['CC-BY-SA', 'Copyright', 'CC-0']"></v-select>
  <v-text-field variant="outlined" label="Authors" v-model="authors" v-model:authors="fileobject.authors" name="authors"></v-text-field>
  <v-text-field variant="outlined" label="Title" v-model="title" v-model:title="fileobject.title" name="titlefield"></v-text-field>
</div>
<div class="d-flex justify-space-between">
    <!-- <v-btn class="my-1" variant="outlined" color="regular" @click="dialogaddpicture = false, datafieldsmenu = false, actionedit = false, actionadd = false">Exit</v-btn> -->
    <v-btn class="my-1" variant="outlined" color="regular" @click="dialogaddpicture = false">Exit</v-btn>
  <v-btn v-if="datafieldsmenu" class="my-1" @click="dialogaddpicture = !dialogaddpicture, addDataToImgRow(), datafieldsmenu = !datafieldsmenu, actionedit = false, actionadd = false">Save</v-btn>
</div>
</v-col>
</v-row>



</v-card-text>
    </v-card>
  </v-dialog>
  
  

  <!--fileobject-->
  
    </template>
    <template v-else>
  
    </template>
  
  </template>
  
  
  <script>
  import axios from 'axios';
  export default {
      name: 'image-widget',
      props:['mode', 'column', 'modelValue', 'imgtitle'],
      emits: ['update:modelValue'],
      components: {
  
      },
      data(){
      return {
        filesprogress: false,
      v: this.modelValue,
      vparsed:[], // инициализация по типу важна - если сделать например так  vparsed: '' (т.е. как строка), то потом этот "объект" будет овсприниматься по типу как строка в методах, хотя typeof будет показывать, что это объект
  //    testv: '',
  //    newmassif: '',
      showimagedialog: false, 
      overlay: false,
      imgsrc: '',
  prefixpath: this.$store.state.mainurl+"/image/data?image=",
//  prefixpath: "https://isling.org/image/data?image=",
  prefixsmall: "",
  prefixfull: "",
  dialogedpicture: false,
  dialogaddpicture: false,
  actionedit: false,
  actionadd: false,
  
  editButton: false,
  license: 'CC-BY-SA',
  authors: '',
  title: '',
  
  indexImg: 0,
  test: {},
  fileobject: {},
  fileinputfield: false,
  insertfilename: '',

  //progressbar:
  interval: {},
  valueprogress: '0',
  datafieldsmenu: false,

  updaterow: {},

  
      }
      },
      mounted(){

                  this.v =  this.modelValue;
//        if(this.v == '' ||this.v == null || this.v == "null"  ||this.v == undefined){
          if (this.modelValue == undefined || this.modelValue == null || this.modelValue == 'null' || this.modelValue == '') {
          this.vparsed = [];
        }
        else {

 this.vparsed = JSON.parse(this.v);
        }
        //console.log(this.vparsed, typeof this.vparsed);
        // console.log(this.vparsed);
      },
  
      methods:{
  
  
        setCurentImg() {
  //            this.curentImgRow = getrow;
              this.editButton = true;
          },

          addDataToImgRow(){
            
            //let newrow = { "title": this.title, "authors": this.authors, "license": this.license, "source": this.files.source, "link": this.files.link, "middle": this.files.middle, "small": this.files.small }
            let newrow = this.fileobject;
//            console.log(newrow);
//            return;
            newrow.title = this.title;
            newrow.authors = this.authors;
            newrow.license = this.license;
            this.fileobject = newrow;
            this.updateImgDataMassif('addimg');
 
          },

          preEdit(){

           this.authors=this.vparsed[this.indexImg].authors;
           this.title=this.vparsed[this.indexImg].title;
           this.license=this.vparsed[this.indexImg].license;

          },

  
  updateImgDataMassif(action){
    if(action == 'deleteimg'){
  this.vparsed.splice(this.indexImg, 1);
  this.vparsed = JSON.stringify(this.vparsed); // преобразование обратно в строку необходимо - иначе ошибка в эмите (потому что получил строку - строку (а не объект) и отдать надо)
  this.$emit('update:modelValue', this.vparsed);
  this.vparsed = JSON.parse(this.vparsed);
  // до сабмита - удаления не происходит (меняется только моделвалью), после сабмита формы удаляется только запись о картинках - сами файлы остаются в хранилище
    }
    else if (action == 'addimg'){

      console.log(this.v, this.modelValue);
      console.log(typeof(this.v), typeof(this.modelValue));

//      if (this.v == undefined || this.v == null) { 
      if (this.modelValue == undefined || this.modelValue == null || this.modelValue == 'null' || this.modelValue == '') { 
        let currentmassifv = [this.fileobject];
        currentmassifv = JSON.stringify(currentmassifv);
        this.$emit('update:modelValue', currentmassifv);
      }
      else {
//        let currentmassifv = this.vparsed;
let currentmassifv = JSON.parse(this.modelValue);
//        console.log(currentmassifv);
        currentmassifv.push(this.fileobject);
        currentmassifv = JSON.stringify(currentmassifv);
        this.$emit('update:modelValue', currentmassifv);
      }


    }
    else if (action == 'editimg'){
      let currentmassifv = this.vparsed;

let updaterow = this.vparsed[this.indexImg];

            updaterow.title = this.title;
            updaterow.authors = this.authors;
            updaterow.license = this.license;
            currentmassifv.splice(this.indexImg, 1, updaterow);
      
            currentmassifv = JSON.stringify(currentmassifv); // преобразование обратно в строку необходимо - иначе ошибка в эмите (потому что получил строку - строку (а не объект) и отдать надо)
            this.$emit('update:modelValue', currentmassifv);


    }
  },
  
  
  // add file method:
        handleFileUpload(){
          this.fileinputfield = false;
          let file = this.$refs.files.files[0];
          this.filesprogress = true; // for progress bar

          let formData = new FormData();

 
          formData.append('files',file);

          let dataset_uri = this.$store.state.mainurl+'/fm/images';
          axios
  //                .post(dataset_uri+'&count_rows=true&iDisplayStart='+0+'&iDisplayLength='+10+filtervalue)
            .post(dataset_uri, formData)
            .then((response) => {

            this.fileobject = response.data.images[0];
//            console.log(this.fileobject);
//            console.log(this.v);

if (this.v == undefined){
            this.vparsed = [this.fileobject];
          }
           // здесь надо получить данные для полей если они пустые - this.vparsed = [{"title":"","authors":"","license":"","source":"","link":"","middle":"","small":""}]; //потому что 299,300,301: v-model:license="vparsed[indexImg].license и т.п. - их надо откуда-то брать

      this.filesprogress = false;

      this.datafieldsmenu = true;
      this.insertfilename = file;
          })
      .catch(error => console.log(error));
    },
  

    // preogressbar(){
    //   this.interval = setInterval(() => {
    //     if (this.valueprogress === 100) {
    //       return (this.valueprogress = 0)
    //     }
    //     this.valueprogress += 10
    //   }, 1000)
    // },
  
          
          showDialog() {
              this.dialogVisible = true;
          }
  
      }, 
      computed:{
      imagesGallery: function(){
//console.log(this.modelValue)
        // проверка с ИЛИ должна быть "позитивной", иначе проверка выйдет из первого же вхождения "неравенства" и остальные не затронет
          if (this.modelValue == '' || this.modelValue == null || this.modelValue == "null" || this.modelValue == undefined || this.modelValue == []) { 
 // checking undefined values - so ok? // or null or undefined?
            return ''; // end of checking
        } else {
          let images=JSON.parse(this.modelValue);

          for(var i=0; i<images.length; i++){

            if (images[i].small == undefined){
/// 
        let addadsmall = ''
            if (images[i].link.includes('/')) {

                              let patchpiese = '';
            patchpiese = images[i].link.split('/');
//console.log('mata',patchpiese);
            addadsmall = patchpiese[0]+'/'+patchpiese[1]+'/'+'small_'+patchpiese[2];
          }
          else {
            addadsmall="small_"+images[i].link
          }

          images[i].small = addadsmall
        }
      }
          /*
                  for(var i=0; i<images.length; i++){

//console.log('mgd5ata',images[i].small)
        if (images[i].small == undefined){
/// 
        let addadsmall = ''
          if (images[i].link.includes('/')) {
//            console.log('mgd5ata',images[i].small)
// здесь порезать линк по слешу засунуть смалл после второго слеша и склеить
            let patchpiese = '';
            patchpiese = images[i].link.split('/');
//console.log('mata',patchpiese);
            addadsmall = patchpiese[0]+'/'+patchpiese[1]+'/'+'small_'+patchpiese[2];
          }
          else {
            addadsmall="small_"+images[i].link
          }
        images[i].small = addadsmall
      }
      this.imglinksmassif.push({small:images[i].small, link: images[i].link, data: imgdata}); 
//          console.log('mgd5ata',this.imglinksmassif)

    }
          
          */

  
          return images;
        }  
      },
  
  
  
    },
    // watch: {
    //   modelValue() {
    //         this.v = this.modelValue;
    //     }
    // }, 
  }
  </script>
  